module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/Header/images/victory-ribbon.987f742b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/Header/images/victory-ribbon.png
// module id = 3237
// module chunks = 11